<template>
  <ValidationProvider
    :vid="vid"
    :name="inputName"
    :rules="rules"
    v-slot="validationContext"
  >
    <b-form-group :id="groupId" :label="inputLabel" :label-for="inputName">
      <b-form-file
        :id="inputName"
        :name="inputName"
        v-model="innerValue"
        :state="getValidationState(validationContext)"
        :aria-describedby="errorId"
        plain
      ></b-form-file>

      <b-form-invalid-feedback :id="errorId">
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "BFileWithValidation",
  components: {
    ValidationProvider,
  },
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
    },
    groupId: { type: String },
    inputLabel: { type: String },
    inputName: { type: String },
    errorId: { type: String },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
<style lang="sass" scoped>
input
  border: 1px solid #bfdfec !important;
  background-color: #f2f9fc !important;
</style>
